/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import Frame, { FrameContextConsumer } from 'react-frame-component';

import HeapTracker from 'components/heap-tracker';

// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import typoTokens from '!!raw-loader!@scalero-inc/forno-design-tokens/styles/design-tokens.typography.css';
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import colorTokens from '!!raw-loader!@scalero-inc/forno-design-tokens/styles/design-tokens.colors.css';
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import colorTokensDark from '!!raw-loader!@scalero-inc/forno-design-tokens/styles/dark-theme/design-tokens.dark-colors.css';
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import spacingTokens from '!!raw-loader!@scalero-inc/forno-design-tokens/styles/design-tokens.spacing.css';
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import borderTokens from '!!raw-loader!@scalero-inc/forno-design-tokens/styles/design-tokens.border.css';

import styles from './styles.module.css';

function BlockPreviewIframe({ children, disableLinks, isStatic }) {
  function DisableAnchorTags({ document }) {
    const anchors = document.querySelectorAll('a');

    anchors.forEach((item) => {
      item.removeAttribute('href');
    });

    return null;
  }

  DisableAnchorTags.propTypes = {
    document: PropTypes.shape({
      querySelectorAll: PropTypes.func,
    }).isRequired,
  };

  return (
    <Frame
      className={styles['block-iframe-wrapper']}
      name="editor preview"
      data-static={isStatic}
      initialContent={`
<!DOCTYPE html><html><head>
<script type="text/javascript">
      (window.heap = window.heap || []),
        (heap.load = function (e, t) {
          (window.heap.appid = e), (window.heap.config = t = t || {});
          var r = document.createElement('script');
          (r.type = 'text/javascript'),
            (r.async = !0),
            (r.src = 'https://cdn.heapanalytics.com/js/heap-' + e + '.js');
          var a = document.getElementsByTagName('script')[0];
          a.parentNode.insertBefore(r, a);
          for (
            var n = function (e) {
                return function () {
                  heap.push(
                    [e].concat(Array.prototype.slice.call(arguments, 0))
                  );
                };
              },
              p = [
                'addEventProperties',
                'addUserProperties',
                'clearEventProperties',
                'identify',
                'resetIdentity',
                'removeEventProperty',
                'setEventProperties',
                'track',
                'unsetEventProperty',
              ],
              o = 0;
            o < p.length;
            o++
          )
            heap[p[o]] = n(p[o]);
        });
</script>
</head><body><div></div></body></html>
`}
    >
      <style>{typoTokens}</style>
      <style>{colorTokens}</style>
      <style>{colorTokensDark}</style>
      <style>{spacingTokens}</style>
      <style>{borderTokens}</style>
      <FrameContextConsumer>
        {({ window, document }) => {
          // eslint-disable-next-line no-unused-expressions
          isStatic
            ? // eslint-disable-next-line no-param-reassign
              (document.body.style.overflow = 'hidden')
            : // eslint-disable-next-line no-param-reassign
              (document.body.style.overflow = 'auto');
          return (
            // scale the iframe content to fit the preview
            <>
              {React.Children.map(children, (child) => {
                if (child) {
                  return React.cloneElement(child, {
                    window,
                    document,
                  });
                }
                return null;
              })}
              {disableLinks ? <DisableAnchorTags document={document} /> : null}
              <HeapTracker window={window} />
            </>
          );
        }}
      </FrameContextConsumer>
    </Frame>
  );
}

BlockPreviewIframe.propTypes = {
  children: PropTypes.node,
  disableLinks: PropTypes.bool,
  isStatic: PropTypes.bool,
};

BlockPreviewIframe.defaultProps = {
  children: null,
  disableLinks: false,
  isStatic: false,
};

export default BlockPreviewIframe;
